import * as React from 'react';
import MUICard, { CardProps } from '@mui/material/Card';
import MUICardActionArea, { CardActionAreaProps } from '@mui/material/CardActionArea';
import MUICardContent, { CardContentProps } from '@mui/material/CardContent';
import MUICardActions, { CardActionsProps } from '@mui/material/CardActions';
import MUICardHeader, { CardHeaderProps } from '@mui/material/CardHeader';
import { PaperProps as MuiPaperProps } from '@mui/material/Paper';

export interface ICardProps extends MuiPaperProps, Pick<CardProps, 'children' | 'style' | 'sx' | 'variant'> {}

export const Card = (props: ICardProps) => {
	return <MUICard {...props} />;
};

export interface ICardActionAreaProps extends Pick<CardActionAreaProps, 'onClick' | 'style' | 'children'> {}

export const CardActionArea = (props: ICardActionAreaProps) => {
	return <MUICardActionArea {...props} />;
};

export const CardActions = (props: CardActionsProps) => {
	return <MUICardActions {...props} />;
};

export const CardContent = (props: CardContentProps) => {
	return <MUICardContent {...props} />;
};

export const CardHeader = (props: CardHeaderProps) => {
	return <MUICardHeader {...props} />;
};
